import { useMutation, useQueryClient } from "@tanstack/react-query";
import { startBreak, endBreak } from "../api/breaks";

function useBreakMutation(mutationFn: typeof startBreak | typeof endBreak) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn,
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ["tawa", "sessions", "open"] });
      void qc.invalidateQueries({
        predicate: (q) =>
          q.queryKey[0] === "tawa" &&
          q.queryKey[1] === "worker" &&
          q.queryKey[2] === "timeline",
      });
    },
  });
}

export function useStartBreak() {
  return useBreakMutation(startBreak);
}

export function useEndBreak() {
  return useBreakMutation(endBreak);
}
